import Get from './get';
import Store from './store';
import Show from './show';
import Update from './update';
import Delete from './delete';

export default {
  Get,
  Store,
  Show,
  Update,
  Delete,
};
